export const ORGANISM = "organism"
export const INDEXORDER = "indexOrder"
export const GENES = "genes"
export const XDIFF = "xDiff"

export const START = "start"
export const END = "end"
export const STRAND = "strand"
export const PRODUCT = "product"
export const PRODUCT_ID = "product_id"
export const PROTEIN_ID = "protein_id"
export const PROTEIN_ID_NAME = "protein_id_name"
export const GENE = "gene"
export const GENE_ID = "gene_id"
export const ID = "id"
export const ID_NAME = "id_name"
export const EC_NUMBER = "ec_number"
export const TRANSLATION = "translation"
export const GENE_LENGTH = "gene_length"
export const PROTEIN_LENGTH = "protein_length"

export const META_PRODUCT = "product"
export const META_PROTEIN_ID = "protein_id"
export const META_GENE = "gene"
export const META_ID = "ID"

export const UPLOAD_TRACK = "track_upload"
export const INPUT_TRACK = "track_input"
export const UPLOAD_META = "meta_upload"
export const INPUT_META = "meta_input"


// constant for loader:
export const ANNOTREE_INTERMEDIATE = 1
export const INTERMEDIATE_APPLICATION = 2
export const UPLOAD_APPLICATION = 3

export const ANNOTOOL_INTERMEDIATE = 4
export const ANNOTOOL_APPLICATION = 5

export const STOP_LOADER = 0



// export const ANNOTREE_DATABASE = [{name: "Archaea", id: 'gtdb_archaea_r95'}, {name: "Bacteria", id: 'gtdb_bacteria_r95'}]
export const ANNOTREE_DATABASE = [{name: "Archaea", id: 'gtdb_archaea_r214'}, {name: "Bacteria", id: 'gtdb_bacteria_r214'}]
export const SEARCH_MODE = [{name: "Default ( >=60 identity)", id: 'default'}, {name: "Fast ( >=90 identity)", id: 'fast'}]

// 0 means auto flip, 1 means auto sort, 2 means no algorithm applied
export const UPLOAD_SORT = [{name: "Default order", id: '2'},{name: "Center Sort (require default center)", id: '1'}]



export const MODEL_SELECTION = [{name: "Word2vec", id: 'Word2vec'}]

